import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent'
const CbNluOrLanguageModels = () => {
    return (
        <div className='row pt-20 px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`NLUs, LLMs and SLMs`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20'>
                <div className='col-md-7 pe-15 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You can choose from our pre-built domain-specific NLUs or Language Models.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You can leverage upon us to build your NLU Models or Language Models. 
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You can also bring your own NLU or Language Models.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-5 text-end m-auto py-10'>
                    <img src="/assets/img/llms.jpg" alt="app image" className="radius-20 w-80" style={{}} />
                </div>
            </div>
        </div>
    )
}

export {CbNluOrLanguageModels}